export default "__VITE_ASSET__DkgSRPJt__"